export default __webpack_public_path__ + "static/media/DCM-Logo-EN-RGB-01.60655ab4.png";